import React, { useState } from "react";
import { throttle } from "lodash";
import AddPropsToChildren from "../../../components/AddPropsToChildren";
import useFilter from "../../../hooks/filter.hook";
import { getPointOffset } from "../renderMapPoint";
import { ICONS, ICONS_DIMENSIONS } from "../constants";
import { useSelector } from "react-redux";
import { selectCurrentMap } from "../../../store/mapStore/mapSelectors";
import { getMapScale } from "../../../helpers/mapHelpers";
import GeneralFigureInfluence, { INFLUENCE_COLOR } from "../InfluenceArea/GeneralFigureInfluence";

const _filterIconOffset = getPointOffset('search');

const FilterArea = ({ children, ...props }) => {
  const [ scale, setScale ] = useState(1);
  const filter = useFilter();
  const currentMapModel = useSelector(selectCurrentMap);
  const mapScale = getMapScale(currentMapModel);
  const { coordinatesFilter } = filter.state;
  const { x, y, radius } = coordinatesFilter;
  const radiusInPx = parseFloat(radius) * mapScale;

  const delayedSetScale = throttle((newScale) => {
    setScale(newScale);
  }, 100);

  const onZoom = (newScale) => {
    delayedSetScale(newScale);
  }

  if (!x || !y) {
    return children;
  }

  const filterX = (x - _filterIconOffset.width / scale / 1.5);
  const filterY = (y - _filterIconOffset.height / scale);
  const filterIconDimensions = ICONS_DIMENSIONS.search;

  const extraProps = {
    onZoomHandlers: [ onZoom ],
    mapChildren: (
      <>
        {props.mapChildren}
        {
          (x && y) ? (
              <>
                <image
                  xlinkHref={ICONS.search}
                  width={filterIconDimensions.width / scale}
                  height={filterIconDimensions.height / scale}
                  x={filterX}
                  y={filterY}
                />
                <GeneralFigureInfluence
                  elementProps={
                    {
                      cx: x,
                      cy: y,
                      r: radiusInPx,
                      strokeWidth: Math.min(4 / scale, 4),
                    }
                  }
                  visible={true}
                  color={INFLUENCE_COLOR.FILTER}
                />
              </>
            )
            : null
        }
      </>
    )
  }

  return (
    <AddPropsToChildren
      extraProps={extraProps}
      {...props}
    >
      {children}
    </AddPropsToChildren>
  )
}

export default FilterArea;